import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerField.css';

import ValidatableField from './ValidatableField';


import './TextField.css';

class DatePickerComponent extends ValidatableField {
  constructor(props) {
    super(props);
    // Format the date to be displayed
    const dateString = props.value ? props.value.Date : null;
    const formattedDateString = this.convertDateStringFormat(dateString);
    this.state.dateValue = formattedDateString;
  }
  static get propTypes() {
    return {
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
      editing: PropTypes.bool,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      className: PropTypes.string,
      onChange: PropTypes.func,
      minDate: PropTypes.object,
      maxDate: PropTypes.object
    };
  }

  static get defaultProps() {
    return {
      onChange: () => {}
    };
  }

  getFormattedDateString(value) {
    const dateString = value ? value.Date : null;
    const formattedDateString = this.convertDateStringFormat(dateString);

    return formattedDateString;
  }

  convertDateStringFormat(initialDateString) {
    if (!initialDateString) {
      return null;
    }
    const formattedDateString = moment(initialDateString).format('DD/MM/YYYY');
    return formattedDateString;
  }

  componentWillReceiveProps(props) {
    const dateString = props.value ? props.value.Date : null;
    const formattedDateString = this.convertDateStringFormat(dateString);

    this.setState({ dateValue: formattedDateString });
  }

  onChange(date) {
    const { onChange } = this.props;
    const dateString = date ? moment(date).format('YYYY-MM-DD') : null;

    onChange(dateString);
  }

  onFocus() {
    this.setState({
      hasFocus: true
    });
  }

  onBlur() {
    // If valid date was typed, would already have selected a new value
    // and changed the date, if invalid just reset to most recent date
    const { value } = this.props;
    const dateString = value ? value.Date : null;
    const formattedDateString = this.convertDateStringFormat(dateString);

    this.setState({
      dateValue: formattedDateString,
      hasFocus: false
    });
  }

  validate() {
    const { dateValue } = this.state;
    if (!moment(dateValue).isValid()) {
      this.setValid(false);
      return false;
    }
    this.setValid(true);
    return true;
  }

  showLabel() {
    const { editing } = this.props;
    const { dateValue, hasFocus } = this.state;
    return !editing || !!dateValue || hasFocus;
  }

  handleChangeRaw(input) {
    this.setState({ dateValue: input });
  }

  renderControl() {
    const { value, editing, name, className, label, required,
      placeholder, external, minDate, maxDate } = this.props;
    const dateValue = value ? value.Date : null;
    const minDateValue = minDate ? moment(minDate.Date) : null;
    const maxDateValue = maxDate ? moment(maxDate.Date) : null;
    const selected = dateValue ? moment(dateValue) : null;
    const placeholderText = placeholder || `${label} ${required ? '' : '(opt)'}`;
    const formattedDateString = this.state.dateValue || '';

    if (!editing) {
      return (
        <span className={classnames('DatePickerField', 'is-disabled')}>{formattedDateString}&nbsp;</span>
      );
    }

    return (
      <DatePicker
        name={name}
        className={
          classnames('DatePickerField',
            className,
            { 'is-disabled': !editing },
            { 'is-selected': selected },
            { 'is-clearable': !required }
          )
        }
        selected={selected}
        onChangeRaw={event => this.handleChangeRaw(event.target.value)}
        dateFormat="DD/MM/YYYY"
        value={formattedDateString}
        onChange={date => this.onChange(date)}
        onFocus={() => this.onFocus()}
        onBlur={() => this.onBlur()}
        disabled={!editing}
        minDate={minDateValue}
        maxDate={maxDateValue}
        placeholderText={!this.showLabel() ? placeholderText : ''}
        isClearable={editing && !required}
        popperModifiers={external ? undefined : { preventOverflow: { enabled: true, boundariesElement: document.querySelector('.RecordDetail-detail') } }}
      />
    );
  }
}


export default DatePickerComponent;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/DatePickerField.js